
import { defineComponent, PropType } from 'vue';
import { ITreeFile } from '@/codeGeneration/codeGen';

export default defineComponent({
  name: 'TreeFile',
  props: {
    data: {
      type: Object as PropType<ITreeFile>,
      required: false,
      default: {
        type: 'file',
        name: 'default',
        data: ''
      }
    }
  },
  data(): {} {
    return {};
  },
  methods: {
    onSelected() {
      this.$emit('fileOpened', this.$props.data);
    }
  },
  emits: {
    fileOpened(fileSelected: ITreeFile) {
      return fileSelected.type === 'file';
    }
  }
});
